import { getCountries, getCountryCallingCode } from "libphonenumber-js/max";

let cached;

/**
 * Same shape as vue-tel-input `allCountries` ({ name, iso2, dialCode }), but with
 * English region names only. The library default embeds native script in `name`
 * (e.g. "Pakistan (‫پاکستان‬‎)"), which is why the dropdown looked bilingual.
 */
export function getVueTelEnglishCountries() {
  if (cached) return cached;

  const regionNames =
    typeof Intl !== "undefined" && typeof Intl.DisplayNames !== "undefined"
      ? new Intl.DisplayNames(["en"], { type: "region" })
      : null;

  cached = getCountries()
    .map((iso2Raw) => {
      const iso2 = String(iso2Raw || "").toUpperCase();
      if (!iso2) return null;
      let dialCode;
      try {
        dialCode = String(getCountryCallingCode(iso2));
      } catch {
        return null;
      }
      let name = iso2;
      if (regionNames) {
        try {
          const label = regionNames.of(iso2);
          if (label) name = label;
        } catch {
          /* keep iso2 */
        }
      }
      return { iso2, dialCode, name };
    })
    .filter(Boolean);

  return cached;
}
